import { AsyncPipe } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { InterviewService } from '@App/interview.service';

// One place for the "still processing your answers" indicator: visibility, spinner and text.
// banner: boxed, above the section or dialog buttons.
// question: footer row inside a question card.
@Component({
    selector: 'interview-processing-status',
    imports: [AsyncPipe, MatProgressSpinnerModule],
    host: { '[class.d-block]': "variant() === 'question'" },
    template: `
        @let processing = interviewService.processingIndicator$ | async;
        @let sources = interviewService.processingSources$ | async;
        @if (variant() === 'question') {
            @if (processing && sources?.includes(questionId())) {
                <div class="question-processing d-flex align-items-center text-muted" role="status">
                    <mat-spinner diameter="14"></mat-spinner>
                    <span class="ms-2">Verifying your answers</span>
                </div>
            }
        } @else if (processing) {
            <div role="status" class="d-flex align-items-center text-muted px-3 py-2 rounded border bg-light">
                <mat-spinner diameter="18"></mat-spinner>
                <span class="ms-3">Please wait while we finish processing your answers...@if (sources?.length) { ({{ sources.length }} remaining)}</span>
            </div>
        }
    `,
    styles: `
        /* Standard cards: sit in the card's bottom padding, clear of the field's error area. */
        .question-processing { padding: 4px 20px 12px; margin-top: -12px; font-size: 12px; line-height: 14px; }
        /* Condensed cards have no spacing under the input. */
        :host-context(.question-container:has(.condensed-view)) .question-processing { margin-top: 0; padding-top: 12px; }
    `
})
export class InterviewProcessingStatusComponent {
    protected readonly interviewService = inject(InterviewService);
    readonly variant = input<'banner' | 'question'>('banner');
    readonly questionId = input<string>();
}
